<template>
    <v-container fluid class="login py-0">
        <v-row align="center" justify="center">
            <v-col cols="12" class="div-banner">
                <v-img src="/images/neumann-oficial-contorno.png" class="mx-auto"></v-img>
            </v-col>
            <v-col lg="4" md="6" sm="10" xs="12">
                <v-card style="margin-top: -70px" class="elevation-2">
                    <v-form v-model="form" ref="reset" v-on:submit.prevent="submit($event)">
                        <v-card-text>
                            <v-text-field
                                v-model="email"
                                filled
                                :color="color"
                                append-icon="mdi-at"
                                label="Correo electrónico"
                                clearable
                                :rules="[rules.required, rules.email]"
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="password"
                                filled
                                :color="color"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show ? 'text' : 'password'"
                                @click:append="show = !show"
                                label="Nueva contraseña"
                                clearable
                                :rules="[rules.required, rules.length]"
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="password_confirmation"
                                filled
                                ref="password_confirmation"
                                :color="color"
                                :append-icon="show_confirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show_confirmation ? 'text' : 'password'"
                                @click:append="show_confirmation = !show_confirmation"
                                label="Repetir contraseña"
                                :error-messages="error_message"
                                clearable
                                :rules="[rules.required]"
                            >
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="cancel" type="button" text style="text-transform: lowercase" :color="color">Cancelar</v-btn>
                            <v-btn type="submit" outlined large :color="color" :loading="loading">Actualizar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['token'],
    data: () => ({
        //models
        form: false,
        email:"",
        password:"",
        password_confirmation:"",

        //urls
        img:"/images/reset.png",
        update_url:"/password/update",

        //props
        color: "#000",
        show: false,
        show_confirmation:false,
        loading:false,
        error_message:"",

        //rules
        rules:{
            required: v => !!v || 'El campo es requerido',
            email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
            length: v => !!v && v.length >= 8 || 'La contraseña debe contener al menos 8 caracteres'
        },
    }),

    watch:{
        password:function(val){
            this.password_confirmation = ""

        },

        password_confirmation:function(val){
            if(val !== ""){
                this.error_message = val !== this.password ? "Las contraseñas no coinciden" : ""
            }else{
                this.$refs.password_confirmation.reset()
            }
        }
    },

    methods:{
        submit:function(event){
            this.$refs.reset.validate()
            if(this.form){
                let data = new Object()
                data.token = this.token.token
                data.email = this.email
                data.password = this.password
                data.password_confirmation = this.password_confirmation

                this.loading = true

                axios.post(this.update_url, data).then(response => {
                    this.loading = false
                    location.replace(response.data.home ? '/home' : '/login');

                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }
                })
            }
        },

        cancel:function(){
            location.replace('/login')
        }
    }
}
</script>
